import { ClienteFilter } from './cliente-filter';

export class ClienteFilterStorage {
    filter: ClienteFilter;
    filterValues: Map<string, any>;

    constructor(filter: ClienteFilter) {
        this.filter = filter;
        this.filterValues = new Map();
    }
}
